import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from 'src/app/shared/guard/authentication-guard';
import { Entity } from 'src/app/shared/store/view/types';
import { SalesDashboardComponent } from './sales-dashboard/sales-dashboard.component';
import { SalesComparisonDashboardComponent } from './sales-comparison-dashboard/sales-comparison-dashboard.component';
import { TelephonyComparisonCallsDashboardComponent } from './telephony-comparison-calls/telephony-comparison-calls-dashboard.component';
import { SalesComparisonMarketingDashboardComponent } from './sales-comparison-marketing/sales-comparison-marketing-dashboard.component';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { ModuleId } from '../../../shared/store/navigation/types';
import { HeaderMenuType } from '../../../shared/store/view/types';
import { SalesPersonProductionDashboardComponent } from './sales-person-dashboard/sales-person-production-dashboard/sales-person-production-dashboard/sales-person-production-dashboard.component';
import { SalesPersonCommissionsDashboardComponent } from './sales-person-dashboard/sales-person-commissions-dashboard/sales-person-commissions-dashboard/sales-person-commissions-dashboard.component';

const routes: Routes = [
  {
    path: 'Crm',
    data: {
      breadcrumb: { label: ' ', alias: 'salesDashboard' },
    },
    children: [
      {
        path: '',
        redirectTo: 'Dashboard',
        pathMatch: 'full',
      },
      {
        path: 'Dashboard',
        component: SalesComparisonDashboardComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.SalesDashboard,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'CallsDashboard',
        component: TelephonyComparisonCallsDashboardComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.CallsDashboard,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'MarketingDashboard',
        component: SalesComparisonMarketingDashboardComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.MarketingDashboard,
          breadcrumb: { skip: true },
        },
      },
      // QA-only route exposing the previous charts dashboard side-by-side with the new tables.
      // TODO: remove this route (and possibly `SalesDashboardComponent` itself) once the new
      // dashboard is validated in production and no longer needs visual parity comparison.
      {
        path: 'DashboardLegacy',
        component: SalesDashboardComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.SalesDashboard,
          breadcrumb: { skip: true },
        },
      },
    ],
  },
  {
    path: 'Crm/SalesPersons',
    data: {
      breadcrumb: { label: ' ', alias: 'dashboardTitle' },
    },
    children: [
      {
        path: '',
        redirectTo: 'ProductionDashboard',
        pathMatch: 'full',
      },
      {
        path: 'ProductionDashboard',
        component: SalesPersonProductionDashboardComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.SalesPersonProductDashboard,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'CommissionsDashboard',
        component: SalesPersonCommissionsDashboardComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.SalesPersonCommissionsDashboard,
          breadcrumb: { skip: true },
        },
      },
    ],
  },
  {
    path: 'Crm/SalesPersons/CommissionsDashboard',
    data: {},
    children: [
      {
        path: '',
        component: SalesPersonCommissionsDashboardComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.SalesPersonCommissionsDashboard,
          breadcrumb: { label: ' ', alias: 'dashboardTitle' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SalesDashboardRoutingModule {}
